import { Player } from '@lottiefiles/react-lottie-player'
import React from 'react'

export default function Error404() {
    return (
        <div className='m-auto'>
            <Player autoplay loop src="/lottie/404.json" />
        </div> 
    )
}
